export default {
  title: 'Criar um plano',
  subtitle: 'Comece com um plano em branco ou deixe um modelo preencher as datas e o orçamento para você.',
  templates: 'Começar a partir de um modelo',
  loadingTemplates: 'Carregando modelos a partir do relatório do modelo...',
  close: 'Fechar',
  choosePeriod: 'Escolha o período para "{option}".',
  startMonth: 'Mês de início',
  endMonth: 'Mês de fim',
  startDate: 'Data de início',
  endDate: 'Data de fim',
  selectedPeriod: 'Período selecionado',
  pickStart: 'Escolha o início',
  pickEnd: 'escolha o fim',
  back: 'Voltar',
  continue: 'Continuar'
}
